import { Row, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import { FormattedMessage } from 'react-intl';
import PaletasBodegaTable from "../PaletasBodega/PaletasBodegaTable"
import { PaletasBodegaView } from "./PaletasBodegaView"
import { PaletasBodegaDelete } from "./PaletasBodegaDelete"
import SaveFileResultModal from "./SaveFileResultModal"
import ArchivosBodegaTable from "./ArchivosBodegaTable"
import { ArchivosBodegaDelete } from "./ArchivosBodegaDelete"
import AddIcon from '@mui/icons-material/Add';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'
import StyledDropzone from '../General/StyledDropzone'
import DeleteIcon from '@mui/icons-material/Delete';


export class PaletasBodega_Index extends Component {
    static displayName = PaletasBodega_Index.name;
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var barco_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            deleteBatchModalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            model: {
                barco_Id: barco_Id,
                entrada: "",
                bodega: "",
                proveedor_id: 0,
            },
            semana: {},
            etiquetasCore: [],
            calibres: [],
            cajasPorPaleta: [],
            saveFileResultState: false,
            saveFileResultData: [],
            archivos: [],
            tableSelection: [],
            vaporesSemanales: [],
            uploadModalState: false,
            uploadVaporSemanalId: 0,
            uploadFiles: [],
            uploadError: "",
            uploading: false
        };
        this.state.modelValidation = {
            //entrada: this.state.model.entrada != 0,
            //bodega: this.state.model.bodega != 0,
            //productor: this.state.model.proveedor_Id != 0,
            //archivo: this.state.model.archivo != ""
        }
        this.load_semana = this.load_semana.bind(this);
        this.load_archivos = this.load_archivos.bind(this);
        this.load_vapores_semanales = this.load_vapores_semanales.bind(this);

        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.delete_archivos_onclick = this.delete_archivos_onclick.bind(this);
        this.delete_archivos_modal_guardar_onclick = this.delete_archivos_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
        this.clean_onclick = this.clean_onclick.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.openUploadModal = this.openUploadModal.bind(this);
        this.closeUploadModal = this.closeUploadModal.bind(this);
        this.handleUploadVaporChange = this.handleUploadVaporChange.bind(this);
        this.handleUploadFiles = this.handleUploadFiles.bind(this);
        this.handleUploadRejectedFiles = this.handleUploadRejectedFiles.bind(this);
        this.table_onselect = this.table_onselect.bind(this);
        this.delete_batch = this.delete_batch.bind(this);
        this.deleteBatchModalToggle = this.deleteBatchModalToggle.bind(this)
        this.saveFileResultToggle = this.saveFileResultToggle.bind(this)
    }
    async validate() {
        const token = await authService.getAccessToken();
        var model = this.state.model;
        model.fechaDeCosecha = model.fechaDeCosecha != "" ? model.fechaDeCosecha : null;
        model.fechaDeEmpaque = model.fechaDeEmpaque != "" ? model.fechaDeEmpaque : null;
        const data = JSON.stringify(model);
        const response = await fetch('api/paletasBodega/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            var modalIsValid = !Object.keys(validations).some(function (val) {
                return validations[val] == false;
            });
            this.setState({
                modelValidation: validations,
                modalIsValid: modalIsValid
            }, () => {
                /*this.props.setModalBodyState(this.state);*/
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }
    deleteBatchModalToggle() {
        this.setState({
            deleteBatchModalState: !this.state.deleteBatchModalState
        });
    }
    saveFileResultToggle() {
        this.setState({
            saveFileResultState: !this.state.saveFileResultState
        });
    }

    renderTable() {

        return (
            <div  >
                <div className="d-flex align-items-center justify-content-between mb-2" style={{ width: '100%', maxWidth: 555 }}>
                    <h4 className="mb-0">Importación de archivos</h4>
                    <Button className="AddButton" onClick={this.openUploadModal}>
                        <AddIcon /> Agregar
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={this.deleteBatchModalToggle} outline color="danger" style={{ display: this.state.tableSelection.length === 0 ? 'none' : 'block' }}>
                        <DeleteIcon /> Eliminar ({this.state.tableSelection.length})
                    </Button>
                </div>
                <div><ArchivosBodegaTable data={this.state.archivos} delete_onclick={this.delete_archivos_onclick} table_onselect={this.table_onselect} /></div>
                <hr />
                <Row>
                    <PaletasBodegaTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.uploadModalState} toggle={this.closeUploadModal} centered>
                    <ModalHeader toggle={this.closeUploadModal}>
                        Importación de archivos
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="uploadVaporSemanalId">Naviera - Vapor</Label>
                            <Input
                                id="uploadVaporSemanalId"
                                name="uploadVaporSemanalId"
                                type="select"
                                value={this.state.uploadVaporSemanalId}
                                onChange={this.handleUploadVaporChange}
                                disabled={this.state.uploading}
                            >
                                <option value="0">Seleccione una naviera y vapor</option>
                                {this.state.vaporesSemanales.map(vapor => (
                                    <option key={vapor.vaporSemanal_Id} value={vapor.vaporSemanal_Id}>
                                        {vapor.naviera} - {vapor.barcoViaje || vapor.barco}
                                    </option>
                                ))}
                            </Input>
                            {this.state.vaporesSemanales.length === 0 && (
                                <small className="text-muted">No hay vapores configurados para esta semana.</small>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>Archivos</Label>
                            <StyledDropzone
                                callback={this.handleUploadFiles}
                                onDropRejected={this.handleUploadRejectedFiles}
                                accept={{
                                    'text/plain': ['.txt'],
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
                                }}
                            />
                            <small className="text-muted">Formatos permitidos: .txt y .xlsx</small>
                            {this.state.uploadFiles.length > 0 && (
                                <div className="mt-2">
                                    <strong>{this.state.uploadFiles.length} archivo(s) seleccionado(s):</strong>
                                    <ul className="mb-0">
                                        {this.state.uploadFiles.map(file => <li key={`${file.name}-${file.size}`}>{file.name}</li>)}
                                    </ul>
                                </div>
                            )}
                        </FormGroup>
                        {this.state.uploadError && <div className="alert alert-danger mb-0">{this.state.uploadError}</div>}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeUploadModal} disabled={this.state.uploading}>
                            Cancelar
                        </Button>
                        <Button
                            className="AddButton"
                            onClick={this.saveFile}
                            disabled={this.state.uploading || !Number(this.state.uploadVaporSemanalId) || this.state.uploadFiles.length === 0}
                        >
                            {this.state.uploading ? 'Agregando...' : 'Agregar'}
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal size="lg" isOpen={this.state.deleteBatchModalState} toggle={this.state.deleteBatchModalState} onClosed={this.deleteBatchModalToggle }>
                    <ModalHeader toggle={this.state.deleteBatchModalState}>
                        Eliminar
                    </ModalHeader>
                    <ModalBody>
                        ¿Esta seguro de eliminar los elementos seleccionados?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.delete_batch}>
                            Eliminar
                        </Button>{' '}
                        <Button color="secondary" onClick={this.state.deleteBatchModalState}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                <SaveFileResultModal toggle={this.state.saveFileResultState} data={this.state.saveFileResultData} onClosed={this.saveFileResultToggle }/>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/SemanasAdmin", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.semana.semana_Id + "/PaletasBodega", message: "Archivos", active: false },
            ]} />;

        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='Archivos' /></h2>
                {breadcrumbsData}

                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.semana.nombre}</div>
                    </div>

                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, semana: await this.load_semana(), archivos: await this.load_archivos(), vaporesSemanales: await this.load_vapores_semanales(), tableSelection: [] }, async () => {
            this.setState({ contenedores: [] }, async () => {
                const token = await authService.getAccessToken();
                var queryString = '?semana_id=' + this.state.semana.semana_Id + '&';
                Object.keys(this.state.model).forEach(key => {
                    queryString += key + "=" + this.state.model[key] + "&";
                });
                queryString = queryString.slice(0, -1);
                const response = await fetch('api/paletasBodega' + queryString, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                });
                const responceData = await response.json();
                this.setState({ data: responceData, loading: false });
            });
        });
    }

    async handleChange(event) {

        var model = this.state.model;
        model[event.target.name] = event.target.value;
        if (event.target.name == "entrada") {
            var etiquetaCore = this.state.etiquetasCore.find(x => x.entrada == event.target.value);
            if (etiquetaCore) {
                model["carton"] = etiquetaCore.carton;
            } else {
                model["carton"] = "";
            }

        }
        this.setState({ model: model }, async () => {
            this.validate()
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            //this.delete_modal_guardar_onclick(id);
            this.delete_archivos_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><PaletasBodegaView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></PaletasBodegaView></div>);
        //return (<div><PaletasBodegaView ref={this.modalBodyState}></PaletasBodegaView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/paletasBodega/ManualPost', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()

        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletasBodega/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><PaletasBodegaView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></PaletasBodegaView></div>);
        //return (<div><PaletasBodegaView ref={this.modalBodyState}></PaletasBodegaView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        console.log("this.modalBodyState",this.modalBodyState)
        const response = await fetch('api/paletasBodega/' + this.modalBodyState.paletaBodega_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletasBodega/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><PaletasBodegaDelete setModalBodyState={this.setModalBodyState} data={responceData}></PaletasBodegaDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletasBodega/' + this.modalBodyState.paletaBodega_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_archivos_onclick(id) {
        const modalBody = await this.delete_archivos_modal_body(id);
        this.setState({
            modalHeader: this.delete_archivos_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_archivos_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_archivos_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/archivosBodega/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><ArchivosBodegaDelete setModalBodyState={this.setModalBodyState} data={responceData}></ArchivosBodegaDelete></div>);
    }
    async delete_archivos_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/archivosBodega/DeleteBatch?ids=' + this.modalBodyState.archivoBodega_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            model: {
                entrada: 0,
                bodega: 0,
                productor: 0,
                carton: "",
                fechaDeCosecha: "",
                fechaDeEmpaque: "",
                archivo: "",
                paleta: "",
            }
        });
        await this.validate()
    }

    async setModalBodyState(state) {
        console.log("state", state)
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            console.log("state.modelValidation", state.modelValidation)
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_semana() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_archivos() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/ArchivosBodega?semana_id=' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_vapores_semanales() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/VaporesSemanales?semana_Id=' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) {
            return [];
        }
        const vapores = await response.json();
        return vapores.sort((a, b) => {
            const first = `${a.naviera || ''} ${a.barcoViaje || a.barco || ''}`;
            const second = `${b.naviera || ''} ${b.barcoViaje || b.barco || ''}`;
            return first.localeCompare(second, 'es');
        });
    }
    openUploadModal() {
        this.setState({
            uploadModalState: true,
            uploadVaporSemanalId: 0,
            uploadFiles: [],
            uploadError: ""
        });
    }
    closeUploadModal() {
        if (this.state.uploading) {
            return;
        }
        this.setState({
            uploadModalState: false,
            uploadVaporSemanalId: 0,
            uploadFiles: [],
            uploadError: ""
        });
    }
    handleUploadVaporChange(event) {
        this.setState({ uploadVaporSemanalId: event.target.value, uploadError: "" });
    }
    handleUploadFiles(files) {
        this.setState({ uploadFiles: files, uploadError: "" });
    }
    handleUploadRejectedFiles() {
        this.setState({ uploadFiles: [], uploadError: "Solo se permiten archivos .txt y .xlsx." });
    }
    async saveFile() {
        this.setState({ uploading: true, uploadError: "" });
        try {
            const token = await authService.getAccessToken();
            const data = new FormData();
            data.append("semana_id", this.state.semana.semana_Id);
            data.append("vapor_semanal_id", this.state.uploadVaporSemanalId);
            for (const file of this.state.uploadFiles) {
                data.append('files[]', file, file.name);
            }
            const response = await fetch('api/paletasBodega', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                body: data
            });
            if (!response.ok) {
                const message = await response.text();
                throw new Error(message || 'No se pudieron importar los archivos.');
            }

            const saveFileResults = await response.json();
            this.setState({
                uploadModalState: false,
                uploadVaporSemanalId: 0,
                uploadFiles: [],
                uploading: false,
                saveFileResultData: saveFileResults
            }, async () => {
                await this.populateData();
                this.setState({ saveFileResultState: true });
            });
        }
        catch (error) {
            this.setState({
                uploading: false,
                uploadError: error.message || 'No se pudieron importar los archivos.'
            });
        }
    }
    async table_onselect(ids) {
        /*        const selectedRowsData = ids.map((id) => rows.find((row) => row[keyField] === id));*/
        this.setState({
            tableSelection: ids
        });
    };
    async delete_batch() {
        this.setState({ loading: true },
            async () => {
                const token = await authService.getAccessToken();
                const response = await fetch('api/archivosBodega/DeleteBatch?ids=' + this.state.tableSelection.join(';'), {
                    method: 'DELETE',
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                });
                if (response.ok) {
                    this.deleteBatchModalToggle();
                    await this.populateData();
                }
            }
        );
    }
}
